import React, { useState, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import showToast from "../../components/Common/viewNotification"
import SessionConfig from "../../config/session_config"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import {
    Col,
    Button,
    Container,
    Row,
    Card,
    CardBody,
    ButtonGroup,
    Modal,
    ModalHeader,
    ModalBody} from "reactstrap"
import DataTable from "react-data-table-component"
import LinearIndeterminate from "../../components/Common/LinearIndeterminate"
import { getBanks, deleteBanks } from "../../store/banks/actions"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import BankForm from "./BankForm"
const Bank = () => {
    const dispatch = useDispatch()
    const ref = useRef()
    const [clearSelectedRows, setclearSelectedRows] = useState(false)
    const [columns, setColumns] = useState([])
    const { t } = useTranslation()
    const [selectRows, setSelectRows] = useState([])
    const [modal, setModal] = useState(false)
    const [modalMessage, setModalMessage] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [currentBank, setCurrentBank] = useState(null)
   
    const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))
    const { banks = [], loading, responseDelete,error } = useSelector(state => {
        return {
            loading: state.Banks.loading,
            banks: state.Banks.banks,
            responseDelete: state.Banks.responseDelete,
            error: state.Banks.error,
        }
    });
    useEffect(() => {
        if (error) {
          showError()
        }
      }, [error])
    useEffect(() => {
        document.getElementById("body").className = "fondo2"
        loadData()
    }, [])
    const loadData = async () => {
        initColumns()
        await dispatch(getBanks());
    }
    const toggle = (val) => {
        setModal(val)
    }

    const toggleMessage = () => {
        setModalMessage(!modalMessage)
    }

    const initColumns = () => {
        let columns = [
            {
                name: t("banks:titleDtName"),
                sortable: false,
                wrap: true,
                width: "30%",
                // eslint-disable-next-line react/display-name
                cell: row => (
                    <span>
                        <div className="text-primary text-capitalize">{row.name}</div>
                    </span>
                ),
            },
            {
                name: t("banks:titleDtCode"),
                sortable: false,
                wrap: true,
                width: "30%",
                // eslint-disable-next-line react/display-name
                cell: row => (
                    <span>
                        <div className="text-primary text-capitalize">{row.code}</div>
                    </span>
                ),
            },
            {
                name: t("banks:titleStatus"),
                sortable: false,
                wrap: true,
                width: "80px",
                // eslint-disable-next-line react/display-name
                cell: row => (
                    <>
                        <span
                            to="#"
                            className={
                                row.status === 1
                                    ? "badge badge-soft-primary font-size-11 m-1"
                                    : "badge badge-soft-danger font-size-11 m-1"
                            }
                        >
                            {row.status === 1 ? t("global:active") : t("global:disable")}
                        </span>
                    </>
                ),
            },
            {
                name: "Accion",
                cell: row => (
                    <div className="d-flex gap-3">
                        <Link className="text-success" to="#">
                            <i
                                className="fa fa-edit font-size-18"
                                id="edittooltip"
                                onClick={() => bankEdit(row)}
                            ></i>
                        </Link>
                    </div>
                ),
            },
        ]
        setColumns(columns)
    }

    const bankAdd = () => {
        setIsEdit(false)
        setCurrentBank(null)
        toggle(true)
    }

    const bankEdit = (row) => {
        setIsEdit(true)
        setCurrentBank(row)
        toggle(true)
    }
    const handleRowSelected = React.useCallback(state => {
        setSelectRows(state.selectedRows)
    }, [])

    useEffect(() => {
        if (responseDelete !== null) {
            if (responseDelete.length > 0) {
                showToast(t("global:msgSuccessDeleteList"), "success", t("banks:titleModal"))
                loadData()
            }
        }
    }, [responseDelete])
    
    const showError = async () => {
        await showToast(error, "error", t("error:title"))
      }
    

    const bankDisable = async () => {
        setclearSelectedRows(true)
        let json = {
            selectRows: selectRows,
            auth: auth.id.user.username
        }
        await dispatch(deleteBanks(json))
        setclearSelectedRows(false)
        setSelectRows([])
        toggleMessage()
    }

    return (
        <React.Fragment>
            <SessionConfig ref={ref} />
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={t("global:title")}
                        breadcrumbItem={t("banks:title")}
                    />
                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <label className="text-primary text-uppercase font-size-16">
                                                <i className="fa fa-list font-size-18  me-1 " />
                                                {t("banks:titleBank")}
                                            </label>
                                        </Col>
                                        <Col>
                                            <div className="text-sm-end">
                                                <ButtonGroup>
                                                    <Button color="danger" onClick={toggleMessage}>
                                                        <i className=" fas fa-times-circle me-1 " />
                                                        {t("global:setdisabled")}
                                                    </Button>
                                                    <Button
                                                        color="primary"
                                                        className="font-16 btn-block btn btn-primary"
                                                        onClick={bankAdd}
                                                    >
                                                        <i className="fas fa-plus-circle me-1" />
                                                        {t("global:add")}
                                                    </Button>
                                                </ButtonGroup>
                                            </div>
                                        </Col>

                                        <DataTable
                                            columns={columns}
                                            data={banks ? banks : []}
                                            fixedHeader
                                            fixedHeaderScrollHeight="500px"
                                            dense
                                            selectableRows={true}
                                            onSelectedRowsChange={handleRowSelected}
                                            highlightOnHover
                                            pagination
                                            progressPending={loading}
                                            progressComponent={<LinearIndeterminate />}
                                            clearSelectedRows={clearSelectedRows}
                                            noDataComponent={t("tableOptions:noDataComponent")}
                                            paginationComponentOptions={{
                                                rowsPerPageText: t("tableOptions:rowsPerPageText"),
                                                rangeSeparatorText: t("tableOptions:rangeSeparatorText"),
                                                selectAllRowsItem: true,
                                                selectAllRowsItemText: t("tableOptions:selectAllRowsItemText"),
                                            }}
                                        />
                                        <Modal isOpen={modal} toggle={() => toggle(true)} backdrop={"static"}>
                                            <ModalHeader >
                                                {t("banks:titleBank")}
                                            </ModalHeader>
                                            <ModalBody>
                                                <BankForm
                                                    onClosing={toggle}
                                                    isEdit={isEdit}
                                                    currentBank={currentBank}
                                                    onLoad={loadData}
                                                />
                                            </ModalBody>
                                        </Modal>
                                        <Modal isOpen={modalMessage} toggle={toggleMessage} backdrop={"static"}>
                                            <ModalHeader toggle={toggleMessage} tag="h4" close={<span></span>}>
                                                {t("banks:titleModal")}
                                            </ModalHeader>
                                            <ModalBody>
                                                <Col>
                                                    <div >
                                                        {t("banks:messageDelete")}
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div className="text-end">
                                                        <ButtonGroup>
                                                            <Button
                                                                type="submit"
                                                                className="btn btn-info save-user"
                                                                onClick={() => {
                                                                    bankDisable()
                                                                }}
                                                            >
                                                                <i className=" fas fa-save me-1 "> {"  "}</i>
                                                                {t("supplier:btnModalSave")}
                                                            </Button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger "
                                                                onClick={() => {
                                                                    toggleMessage(false)
                                                                }}
                                                            >
                                                                {" "}
                                                                {t("global:close")}
                                                            </button>
                                                        </ButtonGroup>
                                                    </div>
                                                </Col>
                                            </ModalBody>
                                        </Modal>

                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    )
}
export default Bank 